import { RefObject, useEffect, useState } from "react"

const useChildElmAmount = (
  elm: RefObject<HTMLDivElement>,
  selector: string
) => {
  const [count, setCount] = useState(0)
  useEffect(() => {
    if (!elm.current) return
    setCount(elm.current.querySelectorAll(selector).length)
  }, [elm])
  return count
}

export default useChildElmAmount
